import React from "react";
import { motion } from "framer-motion";
import { Plus, Minus } from "lucide-react";

export default function ItemAction({ item, defaultSize, onAdd, line, updateQty, effectiveAvailable, batchSoldOut, pricePending, soldOutLabel }) {
  const available = item.available !== false;
  return (
    <motion.div layout>
            {!effectiveAvailable ? (
              batchSoldOut && available ? (
                <span data-testid={`stock-sold-out-btn-${item.id}`} className="text-[10px] uppercase font-bold tracking-wider text-white/50 bg-biga-ink/60 border-2 border-biga-ink/20 px-3 py-2 rounded-full cursor-not-allowed">
                  {soldOutLabel}
                </span>
              ) : (
                <span data-testid={`sold-out-btn-${item.id}`} className="text-[10px] uppercase font-bold tracking-wider text-red-600 bg-red-50 border-2 border-red-200 px-3 py-2 rounded-full">
                  {pricePending ? "Price pending" : soldOutLabel}
                </span>
              )
            ) : line ? (
              <div className="flex items-center gap-2 border-2 border-biga-orange bg-biga-orange/5 rounded-full px-2 py-1" data-testid={`stepper-${item.id}`}>
                <button onClick={() => updateQty(item.id, -1)} data-testid={`step-dec-${item.id}`} aria-label={`Decrease ${item.name} quantity`} className="w-8 h-8 flex items-center justify-center rounded-full hover:bg-biga-orange/10"><Minus size={16} /></button>
                <span className="font-bold w-5 text-center text-sm">{line.qty}</span>
                <button onClick={() => updateQty(item.id, 1)} data-testid={`step-inc-${item.id}`} aria-label={`Increase ${item.name} quantity`} className="w-8 h-8 flex items-center justify-center rounded-full bg-biga-orange text-biga-cream"><Plus size={16} /></button>
              </div>
            ) : (
              <motion.button
                whileTap={{ scale: 0.85 }}
                data-testid={`add-btn-${item.id}`}
                onClick={(e) => onAdd(item, defaultSize, e)}
                className="w-12 h-12 rounded-full bg-biga-ink text-biga-cream flex items-center justify-center hover:bg-biga-orange transition-colors focus-visible:ring-4 focus-visible:ring-biga-orange/40"
                aria-label={`Add ${item.name}`}
              >
                <Plus size={22} strokeWidth={2.6} />
              </motion.button>
            )}
    </motion.div>
  );
}
